import { isSSR } from './ssr';

export const JWT = {
  decode: <T>(token: string): T => {
    let decodedToken = '';
    if (isSSR) {
      decodedToken = Buffer.from(token.split('.')[1], 'base64').toString();
    } else {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      decodedToken = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join(''),
      );
    }

    try {
      return JSON.parse(decodedToken) as T;
    } catch (_error) {
      throw new Error('Token is invalid');
    }
  },
};
